import { useMediaQuery, useTheme } from '@mui/material';
import { File } from '@peerless/data-access/strapi';

export type ImageSize = 'large' | 'medium' | 'small' | 'thumbnail';
export type Device = 'mobile' | 'tablet' | 'desktop';
const localUrl = process.env.NEXT_PUBLIC_STRAPI_MEDIA_URL || '/content';

export function formatMediaUrl(image: File, size?: ImageSize) {
  const url = size && image.formats?.[size] ? image.formats?.[size].url : image.url;

  switch (image.provider) {
    case 'local':
      return `${localUrl}${url}`;
    case 'aws-s3':
    default:
      return url ?? '';
  }
}

export function useGetDevice(): Device {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));

  return isMobile ? 'mobile' : isTablet ? 'tablet' : 'desktop';
}
